/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Group_HelpInputs */



/**
* | output |
* | --- |
* | "The linked group is used to populate the source events for translation." |
*
* @param {Linked_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const linked_group_help = /** @type {((inputs?: Linked_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe lié sert à remplir les événements source pour la traduction.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die verknüpfte Gruppe dient dazu, die Quellereignisse für die Übersetzung zu füllen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo collegato viene utilizzato per popolare gli eventi sorgente per la traduzione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Связанная группа используется для заполнения исходных событий для перевода.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo vinculado se utiliza para completar los eventos de origen para la traducción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链接组用于填充要翻译的源事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リンクされたグループは、翻訳のソース イベントを入力するために使用されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिंक्ड ग्रुप का उपयोग अनुवाद के लिए स्रोत घटनाओं को भरने के लिए किया जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo vinculado é usado para preencher os eventos de origem para tradução.")
	return /** @type {LocalizedString} */ ("The linked group is used to populate the source events for translation.")
});